import React from 'react';
import { copyText } from '../lib/clipboard';
import './TrackingCodeSection.css';

import { ReactComponent as CopyIcon } from '../../assets/icons/copy.svg';

const TRACKING_CODE_SNIPPET = `<!-- Polygraph fraud detection -->
<script src="https://cdn.polygraph.net/pg.js"></script>
<!-- Polygraph fraud detection -->`;

const TrackingCodeSection = () => {
  const [copyState, setCopyState] = React.useState('idle');
  const isCopied = copyState === 'copied';

  React.useEffect(() => {
    if (copyState !== 'copied' && copyState !== 'error') return undefined;

    const timeoutId = window.setTimeout(() => {
      setCopyState('idle');
    }, copyState === 'error' ? 2200 : 1400);

    return () => window.clearTimeout(timeoutId);
  }, [copyState]);

  const handleCopy = async () => {
    if (copyState === 'copying') return;

    setCopyState('copying');
    try {
      await copyText(TRACKING_CODE_SNIPPET);
      setCopyState('copied');
    } catch (error) {
      setCopyState('error');
    }
  };

  const copyLabel = copyState === 'copying'
    ? 'Copying'
    : copyState === 'copied'
      ? 'Copied'
      : copyState === 'error'
        ? 'Retry'
        : 'Copy';

  return (
    <div className="modal-section">
      <h4 className="modal-section__title">Tracking code</h4>

      <p className="modal-section__body">
        Install this in your site&apos;s &lt;head&gt; tag. Make sure your UTMs include{' '}
        <code>utm_campaign</code>, <code>utm_source</code>, and <code>utm_term</code>.
      </p>

      <div className="tracking-code">
        <div className="tracking-code__header">
          <span className="tracking-code__label">HTML</span>
          <button
            type="button"
            className={`btn btn-action tracking-code__copy${isCopied ? ' is-confirmed' : ''}`}
            onClick={handleCopy}
            disabled={copyState === 'copying'}
            aria-live="polite"
          >
            <CopyIcon className="icon sm" />
            <span>{copyLabel}</span>
          </button>
        </div>

        <pre className="tracking-code__pre">
          <code>
            <span className="code-token code-token--comment">&lt;!-- Polygraph fraud detection --&gt;</span>
            {'\n'}
            <span className="code-token code-token--tag">&lt;script </span>
            <span className="code-token code-token--attr">src=</span>
            <span className="code-token code-token--string">&quot;https://cdn.polygraph.net/pg.js&quot;</span>
            <span className="code-token code-token--tag">&gt;&lt;/script&gt;</span>
            {'\n'}
            <span className="code-token code-token--comment">&lt;!-- Polygraph fraud detection --&gt;</span>
          </code>
        </pre>
      </div>
    </div>
  );
};

export default TrackingCodeSection;
